<template>
  <div v-if="enabled" class="StickyUrgency">
    <p class="t5">
      <Icon
        class="StickyUrgency__Icon"
        icon="sticky-urgency"
        :aria-hidden="true"
      />
      {{ message }}
    </p>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import Icon from '../Global/Icon.vue';
import { pubSub } from '@utils/PubSub';
import { useCartStore } from './Composables/Store';

const store = useCartStore();

/*
 * The v2 test variant shows this message via a DY experience. It sets
 * promo.urgency.sticky to true and fires dy:sticky:urgency; the flag covers the case
 * where the event lands before this component mounts, the event covers the reverse.
 */
const enabled = ref(window.Brooklinen?.promo?.urgency?.sticky === true);

pubSub.subscribe('dy:sticky:urgency', () => {
  enabled.value = true;
});

const message = computed(() => store.terms?.sticky_urgency?.message ?? '');
</script>
